<template>
    <div class="loading" v-if="loading"></div>
    <template v-else>
        <template v-if="addresses.length">
            <div class="shipping__main__header">
                <a href="#" class="shipping__main__header__icon-link">
                    <span class="icon-Chevron_right"></span>
                </a>
                <h2 class="shipping__main__header__title">
                    انتخاب آدرس و زمان ارسال
                </h2>
            </div>
            <div class="shipping__address">
                <div class="shipping__address__content">
                    <h4 class="shipping__address__title">آدرس تحویل سفارش</h4>
                    <div class="shipping__address__item-wrapper">
                        <div class="shipping__address__item">
                            <span class="shipping__address__item__key">آدرس: </span>
                            <span class="shipping__address__item__vakue">{{address.province.name}}، {{address.city.name}}، {{address.line}}</span>
                        </div>
                        <div class="shipping__address__item">
                            <span class="shipping__address__item__key">کدپستی: </span>
                            <span class="shipping__address__item__vakue">{{address.postalcode}}</span>
                        </div>
                        <div class="shipping__address__item">
                            <span class="shipping__address__item__key">گیرنده: </span>
                            <span class="shipping__address__item__vakue">{{address.name}}</span>
                        </div>
                        <div class="shipping__address__item" v-if="address.phone">
                            <span class="shipping__address__item__key"> شماره ثابت:</span>
                            <span class="shipping__address__item__vakue">{{address.phone}}</span>
                        </div>
                        <div class="shipping__address__item">
                            <span class="shipping__address__item__key"> شماره همراه:</span>
                            <span class="shipping__address__item__vakue">{{address.mobile}}</span>
                        </div>
                    </div>
                </div>
                <SelectAddress
                    v-model="address_id"
                    v-model:open_create="open_create"
                    :addresses="addresses"
                    @onCreate="addressCreated"
                    @onDelete="addressDeleted"
                    @onUpdate="addressUpdated" />
            </div>
        </template>
        <template v-else>
            <div class="row mb-3">
                <div class="col-12 col-lg-9"><div class="alert alert-warning m-0">شما تا کنون آدرسی ثبت نکرده اید.</div></div>
                <div class="col-12 col-lg-3 d-grid"><button class="btn btn-success" @click="open_create = true">افزودن آدرس جدید</button></div>
            </div>
            <SelectAddress
                v-model="address_id"
                v-model:open_create="open_create"
                :addresses="addresses"
                @onCreate="addressCreated"
                @onDelete="addressDeleted"
                @onUpdate="addressUpdated" />
        </template>
    </template>
</template>

<script>
import Modal from "../general/Modal/Modal";
import ModalHeader from "../general/Modal/ModalHeader";
import ModalBody from "../general/Modal/ModalBody";
import SelectAddress from "./SelectAddress";

export default {
    name: "Address",
    components: {SelectAddress, ModalBody, ModalHeader, Modal},
    props: ['modelValue'],
    emits: ['update:modelValue'],
    data: () => ({
        loading: true,
        address_id: null,
        open_create: false,
        addresses: [],
    }),
    computed: {
        address() {
            if (this.addresses.length === 0 || this.address_id === null) {
                return {};
            }
            return this.addresses.filter((address) => {
                return address.id == this.address_id;
            })[0];
        }
    },
    methods: {
        getAddresses() {
            this.loading = true;
            const token = localStorage.getItem('_token');
            let config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            this.axios.get(this.route('api.profile.addresses.list'), config).then(response => {
                this.loading = false;
                this.addresses = response.data.data;
                this.selectDefaultAddress();
            });
        },
        addressCreated(address) {
            this.addresses.push(address);
        },
        addressDeleted(address) {
            this.addresses = this.addresses.filter(_address => {
                return address.id !== _address.id;
            });
            if (this.address_id === address.id) {
                this.address_id = null;
            }
            this.selectDefaultAddress();
        },
        addressUpdated(address) {
            this.addresses = this.addresses.map(_address => {
                return _address.id === address.id ? address : _address;
            });
        },
        selectDefaultAddress() {
            if (this.addresses?.length === 1) {
                this.address_id = this.addresses[0].id;
            } else if (this.addresses.length > 0 && this.address_id === null) {
                this.address_id = this.addresses[0].id;
            }
        }
    },
    watch: {
        address_id() {
            this.$emit('update:modelValue', this.address_id);
        }
    },
    mounted() {
        this.getAddresses();
    }
}
</script>

<style scoped>

</style>
